import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wp1200 withPadding" }
const _hoisted_2 = { class: "mainTitle pages" }
const _hoisted_3 = { class: "cookies-vue" }
const _hoisted_4 = { class: "flex buttons" }
const _hoisted_5 = { class: "verificationStatus" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_check-round icon" }, null, -1)
const _hoisted_7 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueShowdown = _resolveComponent("VueShowdown")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("cookies.policy")), 1),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.content !== null)
          ? (_openBlock(), _createBlock(_component_VueShowdown, {
              key: 0,
              markdown: _ctx.content,
              options: { emoji: true }
            }, null, 8, ["markdown"]))
          : _createCommentVNode("", true),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.consents.system) = $event)),
                disabled: ""
              }, null, 512), [
                [_vModelCheckbox, _ctx.consents.system]
              ]),
              _createTextVNode(_toDisplayString(_ctx.$t("cookies.system")), 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.consents.analytics) = $event)),
                onKeypress: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.consents.analytics = !_ctx.consents.analytics), ["enter"]))
              }, null, 544), [
                [_vModelCheckbox, _ctx.consents.analytics]
              ]),
              _createTextVNode(_toDisplayString(_ctx.$t("cookies.analize")), 1)
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.consents.social) = $event)),
                onKeypress: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.consents.social = !_ctx.consents.social), ["enter"]))
              }, null, 544), [
                [_vModelCheckbox, _ctx.consents.social]
              ]),
              _createTextVNode(_toDisplayString(_ctx.$t("cookies.social")), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_CustomButton, {
            label: _ctx.$t('cookies.all'),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectAllAndClose()))
          }, null, 8, ["label"]),
          _createVNode(_component_CustomButton, {
            class: "choose",
            label: _ctx.$t('cookies.mandatory'),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.save()))
          }, null, 8, ["label"])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showUpdateCookiesDialog,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showUpdateCookiesDialog) = $event)),
      class: "successDialog",
      onHide: _ctx.refresh
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("cookies.success")), 1)
        ]),
        _createElementVNode("button", {
          class: "defaultButton",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showUpdateCookiesDialog = false)),
          tabindex: "0",
          onKeypress: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.showUpdateCookiesDialog = false), ["enter"]))
        }, _toDisplayString(_ctx.$t("dialog.close")), 33)
      ]),
      _: 1
    }, 8, ["visible", "onHide"])
  ], 64))
}